import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-24 bg-zinc-950 border-t border-zinc-900 relative" data-id="element-135">
      <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-136">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="flex flex-col items-center text-center mb-12" data-id="element-137">
          <AlertTriangle className="w-12 h-12 text-amber-500 mb-6" data-id="element-138" />
          <h2 className="font-display text-4xl md:text-5xl text-zinc-100 mb-8" data-id="element-139">
            THE PROBLEM ISN'T YOU.
            <br data-id="element-140" />
            <span className="text-zinc-500" data-id="element-141">IT'S THE SYSTEM.</span>
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        delay: 0.2
      }} className="prose prose-invert prose-lg max-w-none text-zinc-300" data-id="element-142">
          <p className="mb-6" data-id="element-143">
            The tech industry has shifted. The era of the "cushy 9-to-5" is
            being replaced by lean teams and high-pressure targets. When you
            apply through a portal,{' '}
            <strong className="text-amber-400 font-bold bg-amber-500/10 px-2 py-1 rounded" data-id="element-144">
              you are just one of 800 resumes being scanned for keywords by an
              algorithm.
            </strong>
          </p>
          <p data-id="element-145">
            Every day you spend "optimizing" your resume is a day your savings
            account bleeds out. While you wait for a hiring manager to give you
            permission to provide for your family, companies are quietly
            suffering from the exact technical debt you know how to fix. They
            have the budget, but they don't have the "headcount" for a full-time
            hire.
          </p>
        </motion.div>
      </div>
    </section>;
}